import type { GlobalConfig, } from './self-serve/global-config';

function hasConfigs<WindowType>(window: WindowType): window is WindowType & { configs: GlobalConfig, } {
	// eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-explicit-any
	return typeof (window as any).configs !== 'undefined';
}

export function getWindowConfig<KeyType extends keyof GlobalConfig>(name: KeyType) : GlobalConfig[KeyType] | undefined {
	if (!window) {
		return undefined;
	}

	if (!hasConfigs(window)) {
		return undefined;
	}

	return window.configs[name] || undefined;
}

export function getAllAlerts() : GlobalConfig['AlertOverrides'] {
	const allAlerts = getWindowConfig('AlertOverrides');
	if (!Array.isArray(allAlerts)) {
		return undefined;
	}

	return allAlerts;
}
